import api from '@/api/modules/geoLocation'

export default {
  get: async payload => {
    const response = await api.geoLocation(payload)
    return response
  },
}
